<template>
    <div class="transfer">
        <transfer-default />
    </div>
</template>

<script>
import TransferDefault from '@/views/transfer/Default'

export default {
    name: 'transfer',
    components: {
        TransferDefault
    }
}
</script>

<style scoped>
</style>